import { csrfHeaders } from './csrf';

type AutosaveResponse = {
  id: string;
  version: number;
  saved_at: string;
};

let aborter: AbortController | undefined;
let timer: number | undefined;

function statusText(text: string): void {
  const status = document.querySelector<HTMLElement>('#draft-save-status');
  if (status) {
    status.textContent = text;
  }
}

async function save(form: HTMLFormElement, endpoint: string): Promise<boolean> {
  aborter?.abort();
  aborter = new AbortController();
  statusText('Salvando rascunho…');
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: csrfHeaders({ Accept: 'application/json' }),
      body: new FormData(form),
      signal: aborter.signal,
    });
    if (response.status === 409) {
      statusText('Este rascunho mudou em outra aba. Recarregue antes de continuar.');
      return false;
    }
    if (!response.ok) {
      statusText('O rascunho não foi salvo. Use “Salvar rascunho” antes de sair.');
      return false;
    }
    const result = (await response.json()) as AutosaveResponse;
    const id = form.elements.namedItem('draft_id');
    const version = form.elements.namedItem('draft_version');
    if (id instanceof HTMLInputElement) id.value = result.id;
    if (version instanceof HTMLInputElement) version.value = String(result.version);
    statusText(`Rascunho salvo às ${result.saved_at}.`);
    return true;
  } catch (error: unknown) {
    if (!(error instanceof DOMException && error.name === 'AbortError')) {
      statusText('O rascunho não foi salvo. Use “Salvar rascunho” antes de sair.');
    }
    return false;
  }
}

export async function persistDraftNow(form: HTMLFormElement): Promise<boolean> {
  if (timer !== undefined) window.clearTimeout(timer);
  aborter?.abort();
  const endpoint = form.dataset.draftAutosave;
  if (!endpoint) return false;
  return save(form, endpoint);
}

export function bindDraftAutosave(): void {
  const form = document.querySelector<HTMLFormElement>('#form-emitir[data-draft-autosave]');
  if (!form || form.dataset.autosaveBound === 'true') return;
  const endpoint = form.dataset.draftAutosave;
  if (!endpoint) return;
  form.dataset.autosaveBound = 'true';
  const schedule = (): void => {
    if (timer !== undefined) window.clearTimeout(timer);
    timer = window.setTimeout(() => void save(form, endpoint), 800);
  };
  form.addEventListener('input', schedule);
  form.addEventListener('change', schedule);
  form.addEventListener('submit', () => {
    if (timer !== undefined) window.clearTimeout(timer);
    aborter?.abort();
  });
}
